import React from 'react'
import './travel.scss';

export const TravelTo: React.SFC = () => {

  return (
        <div className="travel-to">
          <h1>Travel To Location</h1>
          <p>Eat somewhere you're going</p>
        </div>
  )
};

export default TravelTo;
